import React from 'react'
import { Container } from 'react-bootstrap'

const DesignItYourself = () => {
  return (
    <Container className='mt-4 showcase-container'>
        <h2 className='text-center font-weight-bold mb-0'>Design It Yourself</h2>
        <iframe title='iframe' width="100%" height={3100} src="https://customstudiousa.com/Products/iframeProducts.aspx?compid=0" frameBorder="0" className="ifrmcanvas custom_stud"></iframe>
    </Container>
  )
}

export default DesignItYourself